import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Component that handles subdomain-based redirects
 * Redirects lexique.quiquoiouquand.com to /lexique
 */
export const SubdomainRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const hostname = window.location.hostname;
    
    // Check if accessing via lexique subdomain
    if (hostname === 'lexique.quiquoiouquand.com' || hostname === 'lexique.quiquoiouquand.lovable.app') {
      // Only redirect if not already on /lexique
      if (location.pathname !== '/lexique') {
        navigate('/lexique', { replace: true });
      }
    }
  }, [navigate, location.pathname]);

  return null;
};
